.leaf-fall {
  position: relative;
  display: block;
  width: fit-content;
  line-height: 0;
}

.leaf-fall--inactive {
  display: contents;
}

.leaf-fall__leaves {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.leaf-fall__drop {
  position: absolute;
  inset: 0;
  opacity: 0;
  animation: leaf-fall-drop var(--leaf-duration) ease-in-out var(--leaf-delay) forwards;
}

.leaf-fall__sway {
  position: absolute;
  top: 0;
  left: var(--leaf-x);
  display: block;
  width: var(--leaf-size);
  height: auto;
  animation: leaf-fall-sway calc(var(--leaf-duration) / 3) ease-in-out var(--leaf-delay) 3 alternate;
}

@keyframes leaf-fall-drop {
  0% {
    opacity: 0;
    transform: translateY(-35%);
  }
  12% {
    opacity: 1;
  }
  85% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: translateY(90%);
  }
}

@keyframes leaf-fall-sway {
  from {
    transform: translateX(calc(var(--leaf-dir) * -30%)) rotate(calc(var(--leaf-dir) * -35deg));
  }
  to {
    transform: translateX(calc(var(--leaf-dir) * 30%)) rotate(calc(var(--leaf-dir) * 35deg));
  }
}

@media (prefers-reduced-motion: reduce) {
  .leaf-fall__leaves {
    display: none;
  }
}
